
import { FormCreateUpdateIncubadora } from "../../components";
import { DisenioPaginas } from "../../layout";





export const CrearEncubadora = () => {


    const initialState = {
        nombre: "",
        telefono: "",
        nit: "",
        direccion: "",
        email: "",
        departamento: "",
        ciudad: "",
    }


    return (  

        <DisenioPaginas titulo="Crear Incubadora" url={1} add={false} subtitulo="Información de la incubadora">
            <FormCreateUpdateIncubadora initialState={initialState} />
        </DisenioPaginas>

    )
}
